import Vue from 'vue';

import authService from '@/services/API/AuthService';
import JWTService from '@/services/JWTService';
import { ROLES, TWO_STEPS_AUTH_ROLES } from '@/modules/Auth/constants';
// import SystemService from '@/services/API/SystemService';
// import router from '@/router';

export default {
  namespaced: true,
  state: {
    userData: null,
    userOrganizations: [],
    authenticated: false,
    studentMode: true,
  },
  getters: {
    isAuthenticated(state) {
      return state.authenticated;
    },
    secondStepRequired(state) {
      return state.userData && TWO_STEPS_AUTH_ROLES.includes(state.userData.role);
    },
    userRegion(state) {
      // UPD: Don't use this shit
      // TODO: Временное решение. Убрать опциональную цепочку ?. и null,
      // когда в базе изначально у всех пользователей будут регионы.
      return {
        id: Number(state.userData?.settings?.region?.id) || null,
        code: String(state.userData?.settings?.region?.code) || null,
        name: state.userData?.settings?.region?.name || null,
      };
    },
    userMunicipality(state) {
      // UPD: Don't use this shit
      // TODO: Временное решение. Убрать опциональную цепочку ?. и null,
      // когда в базе изначально у всех пользователей будут муниципалитеты.
      return {
        id: Number(state.userData?.settings?.municipality?.system_id) || null,
        name: state.userData?.settings?.municipality?.name || null,
      };
    },
    isStudent(state, getters) {
      return getters.getUserRole === ROLES.student.value;
    },
    isTeacher(state, getters) {
      return getters.getUserRole === ROLES.teacher.value;
    },
    isOrganization(state, getters) {
      return getters.getUserRole === ROLES.organization.value;
    },
    isOperator(state, getters) {
      return getters.getUserRole === ROLES.operator.value;
    },
    isDepartment(state, getters) {
      return getters.getUserRole === ROLES.department.value;
    },
    isAdmin(state, getters) {
      return getters.getUserRole === ROLES.admin.value;
    },
    isListener(state, getters) {
      return getters.getUserRole === ROLES.listener.value;
    },
    userData(state) {
      return state.userData;
    },
    userOrganizations(state) {
      return state.userOrganizations;
    },
    getUserRole(state, getters) {
      return getters.isAuthenticated && state.userData.role;
    },
    studentMode(state) {
      return state.studentMode;
    },
  },
  actions: {
    AUTHENTICATE: ({ dispatch }, payload) => new Promise((resolve, reject) => {
      authService.auth(payload.username, payload.password, payload.isLocal)
        .then((response) => {
          const userData = dispatch('INIT_USER', {
            accessToken: response.data.access_token,
            refreshToken: response.data.refresh_token,
          });
          resolve(userData);
        })
        .catch((err) => {
          if (err.response.data.result_code === 'UNTF' || err.response.status === 400) {
            Vue.toasted.error('Пользователь с таким логином и паролем не найден', {
              duration: 3000,
              icon: 'alert-circle-outline',
            });
          }
          reject(err);
        });
    }),
    AUTHENTICATE_BY_CODE: ({ dispatch }, payload) => new Promise((resolve, reject) => {
      authService.authByCode(payload.key)
        .then((response) => {
          const userData = dispatch('INIT_USER', {
            accessToken: response.data.access_token,
            refreshToken: response.data.refresh_token,
          });
          resolve(userData);
        })
        .catch((err) => {
          if (err.response.data.result_code === 'UNTF') {
            Vue.toasted.error('Ошибка при авторизации', {
              duration: 3000,
              icon: 'alert-circle-outline',
            });
          }
          reject(err);
        });
    }),
    INIT_USER: (
      { commit, dispatch },
      { accessToken, refreshToken },
    ) => new Promise((resolve) => {
      commit('SET_TOKEN', { access_token: accessToken, refresh_token: refreshToken });
      dispatch('GET_RESOURCES', null, { root: true });
      resolve(dispatch('FETCH_USER'));
    }),
    FETCH_USER({ getters, commit, dispatch }) {
      return authService.getUserInfo()
        .then((userData) => {
          commit('SET_USER_DATA', userData.data.data);
          if (!getters.secondStepRequired) {
            dispatch('SET_AUTHORIZATION', true);
          }
          return userData.data.data;
        });
    },
    SET_AUTHORIZATION({ commit }, value) {
      commit('SET_AUTHENTICATED', value);
    },
    LOGOUT: (context) => new Promise((resolve) => {
      localStorage.removeItem('CoursesSearchLocation');
      authService.logout()
        .then(() => {
          context.commit('RESET_ALL');
          context.commit('SET_DARK_THEME', false, { root: true });
          resolve();
        })
        .catch(() => {
          context.commit('RESET_ALL');
          context.commit('SET_DARK_THEME', false, { root: true });
          resolve();
        });
    }),
    SET_STUDENT_MODE: ({ commit }, value) => {
      commit('SET_STUDENT_MODE', value);
    },
  },
  mutations: {
    SET_TOKEN: (state, payload) => {
      JWTService.setToken(payload.access_token);
      JWTService.setRefreshToken(payload.refresh_token);
    },
    SET_USER_DATA: (state, payload) => {
      state.userData = payload;
      state.userOrganizations = payload.organizations;
    },
    SET_AUTHENTICATED: (state, value) => {
      state.authenticated = value;
    },
    RESET_ALL: (state) => {
      JWTService.clearTokens();
      state.authenticated = false;
      state.userData = null;
      state.userOrganizations = [];
    },
    /**
     * Тестовая мутация для изменения роли
     * @param state
     * @param payload
     * @constructor
     */
    SET_ROLE: (state, payload) => {
      state.userData.role = payload;
    },

    /**
     * Установка часового пояса текущего пользователя
     * @param state
     * @param payload
     * @constructor
     */
    /**
     * Установка режима обучения для роли преподавателя,
     * меняет интерфейс на обучающегося
     *
     * @param state
     * @param payload
     * @constructor
     */
    SET_STUDENT_MODE: (state, payload) => {
      state.studentMode = payload;
    },
  },
};
